import { ReviewFormTemplateType, FormTypeType } from './ReviewFormTemplate.type';

export enum ReviewTemplateTypeType {
  feedback = 'feedback',
  review360 = 'review', // this is the 360 feedback review
  performanceReview = 'review_performance', // this is the latest formal performance review
}

export enum ReviewTemplateVersion {
  one = 1,
  two = 2,
}

export type ReviewTemplateType = {
  name: string;
  description: string;
  isCustom: boolean;
  isUsed: boolean;
  hidden: boolean;
  slug: string;
  createdAt: string;
  templateType: ReviewTemplateTypeType;
  reviewFormTemplates: ReviewFormTemplateType[];
  userId: number;
  version?: ReviewTemplateVersion;
};

export type ReviewTemplateQuestionErrorType = {
  type: 'questionError';
  key: string;
  label: string;
};

export type ReviewTemplateReviewFormErrorType = {
  type: 'reviewFormTemplateError';
  formType: FormTypeType;
  label: string;
};

export type ReviewTemplateErrorType = ReviewTemplateQuestionErrorType | ReviewTemplateReviewFormErrorType;
